import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      nav("/admin");
    } catch (ex) {
      setErr(errMsg(ex, "No se pudo iniciar sesión"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen bg-[#2C2016] lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/images/p27.jpg" alt="Sámara" className="h-full w-full object-cover opacity-80" />
        <p className="absolute bottom-10 left-10 font-display text-6xl italic text-[#FBF8F2]">Panel de la casa</p>
      </div>
      <div className="flex items-center justify-center px-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <Logo light />
          <h1 className="pt-6 font-display text-4xl text-[#FBF8F2]">Iniciar sesión</h1>
          <Input data-testid="admin-email-input" type="email" required placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl border-white/20 bg-white/5 text-[#FBF8F2] placeholder:text-[#C9BBA6]" />
          <Input data-testid="admin-password-input" type="password" required placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl border-white/20 bg-white/5 text-[#FBF8F2] placeholder:text-[#C9BBA6]" />
          {err && <p data-testid="admin-login-error" className="text-sm text-[#f0a58a]">{err}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className="w-full rounded-xl bg-[#C4823F] py-3.5 font-semibold text-[#1f160e] transition-colors hover:bg-[#d6955a] disabled:opacity-60">{busy ? "Entrando…" : "Entrar"}</button>
        </form>
      </div>
    </div>
  );
}
